import {
  Bot,
  Users,
  ClockCheck,
  MessageCircleCheck,
  Laugh,
  Annoyed,
  Angry,
} from 'lucide-react'
import type { DashboardStats } from '@/types/api'

interface Props {
  stats: DashboardStats
}

export function StatsCards({ stats }: Props) {
  const items = [
    {
      icon: <Bot className="h-4 w-4 text-[#CE7A58]" />,
      label: 'Robot hoạt động',
      value: stats.totalRobots,
      color: '!border-[#CE7A58]',
    },
    {
      icon: <Users className="h-4 w-4 text-[#03A6EB]" />,
      label: 'Lượt tiếp đón',
      value: stats.totalReceptions.toLocaleString('vi-VN'),
      color: 'border-[#03A6EB]',
    },
    {
      icon: <ClockCheck className="h-4 w-4 text-[#6A25DD]" />,
      label: 'Thời gian tương tác',
      value: `${(stats.totalSessionDuration || 0).toLocaleString('vi-VN')} h`,
      color: 'border-[#6A25DD]',
    },
    {
      icon: <MessageCircleCheck className="h-4 w-4 text-[#F96B05]" />,
      label: 'Tổng lượt đánh giá',
      value: stats.totalReviews.toLocaleString('vi-VN'),
      color: 'border-[#F96B05]',
    },
    {
      icon: <Laugh className="h-4 w-4 text-[#16A249]" />,
      label: 'Hài lòng',
      value: stats.satisfiedCount.toLocaleString('vi-VN'),
      color: 'border-[#16A249]',
    },
    {
      icon: <Annoyed className="h-4 w-4 text-[#EBA601]" />,
      label: 'Bình thường',
      value: stats.neutralCount.toLocaleString('vi-VN'),
      color: 'border-[#EBA601]',
    },
    {
      icon: <Angry className="h-4 w-4 text-[#DD2A2D]" />,
      label: 'Không hài lòng',
      value: stats.unsatisfiedCount.toLocaleString('vi-VN'),
      color: 'border-[#DD2A2D]',
    },
  ]

  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-7">
      {items.map((item, i) => (
        <div
          key={i}
          className={`flex flex-col justify-between rounded-xl border border-solid ${item.color} bg-white p-3.5 shadow-sm transition-all hover:shadow-md`}
        >
          <div className="mb-2 flex items-center gap-1.5 text-xs font-medium text-gray-600">
            {item.icon}
            <span className="truncate">{item.label}</span>
          </div>
          <div className="text-xl font-bold text-gray-900">{item.value}</div>
        </div>
      ))}
    </div>
  )
}
